import Cookies from "js-cookie";

import type { CookieName } from "./cookieKeys";

import { getCookieKey } from "./cookieKeys";

export const setCookie = (name: CookieName, value: string) => {
  // get the domain in the format .example.com so that the cookies work across subdomains
  const domain = "." + document.location.hostname.split(".").slice(-2).join(".");
  Cookies.set(getCookieKey(name), value, { domain, path: "/", secure: true, sameSite: "strict", expires: 360 });
};

export const getCookieValue = (name: CookieName) => {
  return Cookies.get(getCookieKey(name));
};
